!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.DatoCmsSearch = t() : e.DatoCmsSearch = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 3);
  }([function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      !function (n) {
        function o() {}
        function r(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }
        function i(e) {
          if (!(this instanceof i)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof e) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], l(e, this);
        }
        function c(e, t) {
          for (; 3 === e._state;) e = e._value;
          if (0 === e._state) return void e._deferreds.push(t);
          e._handled = !0, i._immediateFn(function () {
            var n = 1 === e._state ? t.onFulfilled : t.onRejected;
            if (null === n) return void (1 === e._state ? u : a)(t.promise, e._value);
            var o;
            try {
              o = n(e._value);
            } catch (e) {
              return void a(t.promise, e);
            }
            u(t.promise, o);
          });
        }
        function u(e, t) {
          try {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
            if (t && ("object" == typeof t || "function" == typeof t)) {
              var n = t.then;
              if (t instanceof i) return e._state = 3, e._value = t, void s(e);
              if ("function" == typeof n) return void l(r(n, t), e);
            }
            e._state = 1, e._value = t, s(e);
          } catch (t) {
            a(e, t);
          }
        }
        function a(e, t) {
          e._state = 2, e._value = t, s(e);
        }
        function s(e) {
          2 === e._state && 0 === e._deferreds.length && i._immediateFn(function () {
            e._handled || i._unhandledRejectionFn(e._value);
          });
          for (var t = 0, n = e._deferreds.length; t < n; t++) c(e, e._deferreds[t]);
          e._deferreds = null;
        }
        function f(e, t, n) {
          this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
        }
        function l(e, t) {
          var n = !1;
          try {
            e(function (e) {
              n || (n = !0, u(t, e));
            }, function (e) {
              n || (n = !0, a(t, e));
            });
          } catch (e) {
            if (n) return;
            n = !0, a(t, e);
          }
        }
        var d = setTimeout;
        i.prototype.catch = function (e) {
          return this.then(null, e);
        }, i.prototype.then = function (e, t) {
          var n = new this.constructor(o);
          return c(this, new f(e, t, n)), n;
        }, i.all = function (e) {
          return new i(function (t, n) {
            function o(e, c) {
              try {
                if (c && ("object" == typeof c || "function" == typeof c)) {
                  var u = c.then;
                  if ("function" == typeof u) return void u.call(c, function (t) {
                    o(e, t);
                  }, n);
                }
                r[e] = c, 0 == --i && t(r);
              } catch (e) {
                n(e);
              }
            }
            if (!e || void 0 === e.length) throw new TypeError("Promise.all accepts an array");
            var r = Array.prototype.slice.call(e);
            if (0 === r.length) return t([]);
            for (var i = r.length, c = 0; c < r.length; c++) o(c, r[c]);
          });
        }, i.resolve = function (e) {
          return e && "object" == typeof e && e.constructor === i ? e : new i(function (t) {
            t(e);
          });
        }, i.reject = function (e) {
          return new i(function (t, n) {
            n(e);
          });
        }, i.race = function (e) {
          return new i(function (t, n) {
            for (var o = 0, r = e.length; o < r; o++) e[o].then(t, n);
          });
        }, i._immediateFn = "function" == typeof t && function (e) {
          t(e);
        } || function (e) {
          d(e, 0);
        }, i._unhandledRejectionFn = function (e) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        }, i._setImmediateFn = function (e) {
          i._immediateFn = e;
        }, i._setUnhandledRejectionFn = function (e) {
          i._unhandledRejectionFn = e;
        }, void 0 !== e && e.exports ? e.exports = i : n.Promise || (n.Promise = i);
      }(this);
    }).call(t, n(8).setImmediate);
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    } /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
    var r = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      c = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var o = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          o[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, u, a = o(e), s = 1; s < arguments.length; s++) {
        n = Object(arguments[s]);
        for (var f in n) i.call(n, f) && (a[f] = n[f]);
        if (r) {
          u = r(n);
          for (var l = 0; l < u.length; l++) c.call(n, u[l]) && (a[u[l]] = n[u[l]]);
        }
      }
      return a;
    };
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      return t.replace(/\[h\](.+?)\[\/h\]/g, function (t, n) {
        var o = document.createElement("div");
        return o.innerHTML = e, o.children[0].innerText = n, o.children[0].outerHTML;
      });
    }
    function r(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "production";
      this.apiToken = e, this.environment = t;
    }
    var i = n(5),
      c = (n(2), "undefined" != typeof window ? window.Promise || n(1) : n(1));
    r.prototype = {
      search: function search(e, t) {
        t = Object.assign({
          highlightWith: '<strong class="highlight"></strong>',
          locale: null
        }, t);
        var n = "https://site-api.datocms.com/search-results?";
        n += "q=" + encodeURIComponent(e), n += "&environment=" + encodeURIComponent(this.environment), t.locale && (n += "&locale=" + encodeURIComponent(t.locale)), t.offset && (n += "&offset=" + encodeURIComponent(t.offset)), t.limit && (n += "&limit=" + encodeURIComponent(t.limit));
        var r = {
            url: n,
            headers: {
              Authorization: "API-Token " + this.apiToken,
              Accept: "application/json"
            }
          },
          u = o.bind(null, t.highlightWith);
        return new c(function (e, t) {
          i.ajax(r, function (n, o) {
            if (401 === n) return void t(new Error("[DatoCMS Site Search] Invalid API token: make sure the API token exists and has the proper permissions!"));
            var r = JSON.parse(o),
              i = r.data.map(function (e) {
                var t = e.attributes.highlight;
                return {
                  url: e.attributes.url,
                  title: t.title ? u(t.title[0]) : e.attributes.title,
                  body: t.body ? "..." + t.body.map(function (e) {
                    return u(e.trim());
                  }).join("...") + "..." : e.attributes.body_excerpt,
                  raw: {
                    title: e.attributes.title,
                    body: e.attributes.body_excerpt
                  }
                };
              });
            e({
              results: i,
              total: r.meta.total_count
            });
          });
        });
      }
    }, e.exports = r;
  },, function (e, t, n) {
    (function (e) {
      function n(t) {
        return t && e.XDomainRequest && !/MSIE 1/.test(navigator.userAgent) ? new XDomainRequest() : e.XMLHttpRequest ? new XMLHttpRequest() : void 0;
      }
      function o(e, t, n) {
        e[t] = e[t] || n;
      }
      var r = ["responseType", "withCredentials", "timeout", "onprogress"];
      t.ajax = function (t, i) {
        function c(e, t) {
          return function () {
            f || (i(void 0 === l.status ? e : l.status, 0 === l.status ? "Error" : l.response || l.responseText || t, l), f = !0);
          };
        }
        var u = t.headers || {},
          a = t.body,
          s = t.method || (a ? "POST" : "GET"),
          f = !1,
          l = n(t.cors);
        l.open(s, t.url, !0);
        var d = l.onload = c(200);
        l.onreadystatechange = function () {
          4 === l.readyState && d();
        }, l.onerror = c(null, "Error"), l.ontimeout = c(null, "Timeout"), l.onabort = c(null, "Abort"), a && (o(u, "X-Requested-With", "XMLHttpRequest"), e.FormData && a instanceof e.FormData || o(u, "Content-Type", "application/x-www-form-urlencoded"));
        for (var p, h = 0, m = r.length; h < m; h++) p = r[h], void 0 !== t[p] && (l[p] = t[p]);
        for (var p in u) l.setRequestHeader(p, u[p]);
        return l.send(a), l;
      };
    }).call(t, n(0));
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function o() {
      throw new Error("clearTimeout has not been defined");
    }
    function r(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);
      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }
    function i(e) {
      if (l === clearTimeout) return clearTimeout(e);
      if ((l === o || !l) && clearTimeout) return l = clearTimeout, clearTimeout(e);
      try {
        return l(e);
      } catch (t) {
        try {
          return l.call(null, e);
        } catch (t) {
          return l.call(this, e);
        }
      }
    }
    function c() {
      m && p && (m = !1, p.length ? h = p.concat(h) : v = -1, h.length && u());
    }
    function u() {
      if (!m) {
        var e = r(c);
        m = !0;
        for (var t = h.length; t;) {
          for (p = h, h = []; ++v < t;) p && p[v].run();
          v = -1, t = h.length;
        }
        p = null, m = !1, i(e);
      }
    }
    function a(e, t) {
      this.fun = e, this.array = t;
    }
    function s() {}
    var f,
      l,
      d = e.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }
      try {
        l = "function" == typeof clearTimeout ? clearTimeout : o;
      } catch (e) {
        l = o;
      }
    }();
    var p,
      h = [],
      m = !1,
      v = -1;
    d.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      h.push(new a(e, t)), 1 !== h.length || m || r(u);
    }, a.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, d.title = "browser", d.browser = !0, d.env = {}, d.argv = [], d.version = "", d.versions = {}, d.on = s, d.addListener = s, d.once = s, d.off = s, d.removeListener = s, d.removeAllListeners = s, d.emit = s, d.prependListener = s, d.prependOnceListener = s, d.listeners = function (e) {
      return [];
    }, d.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, d.cwd = function () {
      return "/";
    }, d.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, d.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        function o(e) {
          "function" != typeof e && (e = new Function("" + e));
          for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
          var o = {
            callback: e,
            args: t
          };
          return s[a] = o, u(a), a++;
        }
        function r(e) {
          delete s[e];
        }
        function i(e) {
          var t = e.callback,
            o = e.args;
          switch (o.length) {
            case 0:
              t();
              break;
            case 1:
              t(o[0]);
              break;
            case 2:
              t(o[0], o[1]);
              break;
            case 3:
              t(o[0], o[1], o[2]);
              break;
            default:
              t.apply(n, o);
          }
        }
        function c(e) {
          if (f) setTimeout(c, 0, e);else {
            var t = s[e];
            if (t) {
              f = !0;
              try {
                i(t);
              } finally {
                r(e), f = !1;
              }
            }
          }
        }
        if (!e.setImmediate) {
          var u,
            a = 1,
            s = {},
            f = !1,
            l = e.document,
            d = Object.getPrototypeOf && Object.getPrototypeOf(e);
          d = d && d.setTimeout ? d : e, "[object process]" === {}.toString.call(e.process) ? function () {
            u = function u(e) {
              t.nextTick(function () {
                c(e);
              });
            };
          }() : function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? function () {
            var t = "setImmediate$" + Math.random() + "$",
              n = function n(_n) {
                _n.source === e && "string" == typeof _n.data && 0 === _n.data.indexOf(t) && c(+_n.data.slice(t.length));
              };
            e.addEventListener ? e.addEventListener("message", n, !1) : e.attachEvent("onmessage", n), u = function u(n) {
              e.postMessage(t + n, "*");
            };
          }() : e.MessageChannel ? function () {
            var e = new MessageChannel();
            e.port1.onmessage = function (e) {
              c(e.data);
            }, u = function u(t) {
              e.port2.postMessage(t);
            };
          }() : l && "onreadystatechange" in l.createElement("script") ? function () {
            var e = l.documentElement;
            u = function u(t) {
              var n = l.createElement("script");
              n.onreadystatechange = function () {
                c(t), n.onreadystatechange = null, e.removeChild(n), n = null;
              }, e.appendChild(n);
            };
          }() : function () {
            u = function u(e) {
              setTimeout(c, 0, e);
            };
          }(), d.setImmediate = o, d.clearImmediate = r;
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(t, n(0), n(6));
  }, function (e, t, n) {
    (function (e) {
      function o(e, t) {
        this._id = e, this._clearFn = t;
      }
      var r = void 0 !== e && e || "undefined" != typeof self && self || window,
        i = Function.prototype.apply;
      t.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new o(i.call(setInterval, r, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(7), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(t, n(0));
  }]);
});